import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RuleConfigRoutingModule } from './rule-config-routing.module';
import { RuleConfigListComponent } from './components/rule-config-list/rule-config-list.component';
import { RuleConfigAddComponent } from './components/rule-config-add/rule-config-add.component';
import { AngularmaterialModule } from '../../modules/angular-material-module';
import { SharedModule } from '../../modules/shared.module';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';


@NgModule({
  declarations: [
    RuleConfigListComponent,
    RuleConfigAddComponent
  ],
  imports: [
    CommonModule,
    RuleConfigRoutingModule,
    AngularmaterialModule,
    SharedModule,
  ],
  providers: [
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher}
  ]
})
export class RuleConfigModule { }
